/**
 * Colours manipulation utils
 * Uses tinycolor in the background
 */
import tinycolor from 'tinycolor2';

/**
 * Lighten a colour a given amount.
 *
 * @param  {String} colour - colour hexa RGB
 * @param  {Number} [amount=10] - amount to lighten, between 0 & 100.
 *                  100 will always return white
 * @return {String} new lightened colour hexa RBG string
 */
const lighten = (colour, amount = 10) => tinycolor(colour).lighten(amount).toHexString();

/**
 * Darken a colour a given amount.
 *
 * @param  {String} colour - colour hexa RGB
 * @param  {Number} [amount=10] - amount to darken, between 0 & 100
 *                  100 will always return black
 * @return {String} new darkened colour hexa RBG string
 */
const darken = (colour, amount = 10) => tinycolor(colour).darken(amount).toHexString();

export { lighten, darken };
